import { DateRange } from './date';

export class MerchantTransactions {
    id: number;
    userId: number;
    walletId: number;
    accountNo: string;
    appCode: string;
    transactionType: string;
    currency: string;
    amount: number;
    balance: number;
    transactionStatus: string;
    accountType: string;
    category: string;
    narration: string;
    message: string;
    createdBy: number;
    updatedBy: number;
}
export class MerchantTransactionSearch {
    createdDate: DateRange = DateRange.empty();
    transactionStatus: number;
    transactionType: number;
    mobileNo = '';
    accountNo = '';
    paymentTypes: number;
    merchantId: number = 0;
    locationId: any;
    settledStatus: number;
    isSettled: any;
    isRefunded: boolean;
    userId = '';
    agent: number;
    field: 'transactionType'| 'transactionStatus' = 'transactionType';
    value: '';
    type = 'mobile_no';
    number = '';
    appCode = '';
    accountType: any;
    id = '';
    name = '';
    status = '';
    settlementStatus = '';
    paymentMethod: any;
    isSettlement ='';
    isOrderDelivered: boolean;
    settlementDocId : any;
}
export class MerchantCategoryCodeSearch {
        createdDate: DateRange = DateRange.empty();
        id = '';
        code = '';
        description = '';
        isProhibited='';
}
